import { getFallbackServerUrl } from './constants';
var AppConfigValidDataKeys;
(function (AppConfigValidDataKeys) {
    AppConfigValidDataKeys["FALLBACK"] = "fallback";
    AppConfigValidDataKeys["INITIALIZED"] = "initialized";
})(AppConfigValidDataKeys || (AppConfigValidDataKeys = {}));
var AppConfig = /** @class */ (function () {
    function AppConfig() {
        var _a;
        this.data = {
            serverUrl: (_a = {},
                _a[AppConfigValidDataKeys.FALLBACK] = getFallbackServerUrl(),
                _a[AppConfigValidDataKeys.INITIALIZED] = null,
                _a),
        };
    }
    Object.defineProperty(AppConfig.prototype, "SERVER_URL", {
        get: function () {
            var serverUrl = this.data.serverUrl;
            return serverUrl.initialized !== null
                ? serverUrl.initialized
                : serverUrl.fallback;
        },
        set: function (serverUrl) {
            if (this.data.serverUrl.initialized) {
                // eslint-disable-next-line no-console
                console.warn('Server URL already initialized. This is a noop');
                return;
            }
            if (!serverUrl) {
                // eslint-disable-next-line no-console
                console.warn('Cannot initialize empty value');
                return;
            }
            this.data.serverUrl.initialized = serverUrl;
            return;
        },
        enumerable: false,
        configurable: true
    });
    return AppConfig;
}());
var appConfigSingleton = new AppConfig();
export default appConfigSingleton;
